<template>
  <section class="product-cancellation">
    <div class="travel-tabs">
      <div class="tab-icons" :class="isSavingData ? 'is-saving' : ''">
        <div
          v-if="salesAdditiveType === 'Alterar'"
          class="tab grayscale"
          :class="activeTab === 'product' ? 'active' : ''"
          @click="onClickActiveTab('product')"
        >
          <img
            src="@/assets/images/dashboard/contracts/hotel-ico.png"
            alt="img"
            height="30"
          />
        </div>
        <div
          class="tab grayscale"
          :class="activeTab === 'financial' ? 'active' : ''"
          @click="onClickActiveTab('financial')"
        >
          <img
            src="@/assets/images/dashboard/contracts/financial-icon.png"
            alt="img"
            height="30"
          />
        </div>
        <div
          class="tab grayscale"
          :class="activeTab === 'incomings' ? 'active' : ''"
          @click="onClickActiveTab('incomings')"
          v-if="fineFee || supplierFineFee"
        >
          <img
            src="@/assets/images/dashboard/contracts/incomings-icon.png"
            alt="img"
            height="30"
          />
        </div>
      </div>
      <div class="tab-content">
        <aRow>
          <aCol class="inner-content" :span="24">
            <template v-if="activeTab === 'product'">
              <div class="tab-header">Produto</div>
              <div class="pr-10 pt-10">
                <ContractModalHotelRow
                  :product="productToCancel"
                  :tempContract="tempContract"
                  :allContractData="allContractData"
                  @onIsSavingData="onIsSavingData"
                  @onChangeCancelProductData="onChangeCancelProductData"
                  type="edit"
                />
              </div>
            </template>
            <template v-if="activeTab === 'financial'">
              <div class="tab-header">Financeiro</div>
              <div class="pr-10 pt-10">
                <ContractCancelHotelFinancialForm
                  :product="productToCancel"
                  :tempContract="tempContract"
                  :allContractData="allContractData"
                  :newProductValues="newProductValues()"
                  :totalFees="totalFees"
                  @onIsSavingData="onIsSavingData"
                  @onChangeFees="onChangeCancelProductData"
                  @onChangeCancelProductData="onChangeCancelProductData"
                  @onChangeFeeValue="onChangeFeeValue"
                />
              </div>
            </template>

            <template
              v-if="activeTab === 'incomings' && (fineFee || supplierFineFee)"
            >
              <div class="tab-header">Recebimentos</div>
              <div class="pr-10 pt-10">
                <ContractPaymentsReceivable
                  :tempContract="tempContract"
                  :productsToCancel="productsToCancel"
                  :keyPrefix="''"
                  :keySuffix="'_new'"
                  :baseId="baseId"
                  :baseFinancesId="baseFinancesId"
                  :salesAdditiveType="salesAdditiveType"
                  @onIsSavingData="onIsSavingData"
                  @onChangeCancelProductData="onChangeCancelProductData"
                />
              </div>
            </template>
          </aCol>

          <aCol
            v-if="['Alterar', 'Cancelar'].includes(salesAdditiveType)"
            :span="24"
          >
            <aRow class="footer" :gutter="20" align="middle">
              <aCol class="disclaimer f12" :span="16">
                <b>Atenção:</b> Preencha todos os campos obrigatórios para
                {{ salesAdditiveType }} o produto.
              </aCol>
              <aCol class="a-right" :span="8">
                <aButton
                  icon="close-circle"
                  type="danger"
                  :disabled="disableCancelProduct"
                  style="padding: 0 10px"
                  @click="onClickCancelProduct"
                >
                  {{ salesAdditiveType }} Produto
                </aButton>
              </aCol>
            </aRow>

            <aModal
              class="cancel-sale-modal"
              :visible="openCancelProductModal"
              :footer="false"
              :width="600"
              @cancel="openCancelProductModal = false"
            >
              <template #title>
                <div class="upper">{{ salesAdditiveType }} PRODUTO</div>
              </template>

              <ContractCancelProductModal
                v-if="openCancelProductModal"
                :tempContract="tempContract"
                :allContractData="allContractData"
                :totalFees="totalFees"
                :productTotalValue="productTotalValue"
                :cancelActions="cancelActions"
                :productValues="productValues()"
                :salesAdditiveType="salesAdditiveType"
                product="hotel"
                :productToCancel="productToCancel"
                :baseFinancesId="baseFinancesId"
                :baseId="baseId"
                @onFinishActions="onFinishActions"
              />
            </aModal>
          </aCol>
        </aRow>
        <div id="live-debug">
          <json-viewer
            :value="tempContract"
            :show-array-index="false"
            :expand-depth="1"
          ></json-viewer>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { parse } from "vue-currency-input";
import formatThings from "@/mixins/general/formatThings.js";
import ContractModalHotelRow from "../sections/ContractModalHotelRow.vue";
import ContractCancelHotelFinancialForm from "../sections/ContractCancelHotelFinancialForm.vue";
import ContractPaymentsReceivable from "../sections/ContractPaymentsReceivable.vue";
import ContractCancelProductModal from "./ContractCancelProductModal.vue";

export default {
  name: "CancelHotelModal",
  props: {
    productToCancel: Object,
    tempContract: Object,
    salesAdditiveType: String,
    allContractData: Object,
    productsToCancel: Array,
    totalFees: Number,
  },
  components: {
    ContractModalHotelRow,
    ContractCancelHotelFinancialForm,
    ContractPaymentsReceivable,
    ContractCancelProductModal,
  },
  mixins: [formatThings],
  data() {
    return {
      activeTab: "financial",
      disableCancelProduct: true,
      isSavingData: false,
      fineFee: false,
      supplierFineFee: false,
      openCancelProductModal: false,
      baseFinancesId: `contract_finances_hotel_${this.productToCancel.id}`,
      baseId: `hotel_${this.productToCancel.id}`,
      cancelActions: [],
      productTotalValue: 0
    };
  },
  mounted() {
    if (["Alterar", "Cancelar"].includes(this.salesAdditiveType)) {
      this.activeTab =
        this.salesAdditiveType === "Alterar" ? "product" : "financial";
      this.verifyProductForCancellation();
    }

    this.fineFee = this.checkActive(
      this.tempContract[
        `contract_finances_hotel_${this.productToCancel.id}_fine_fee_active`
      ]
    );

    this.supplierFineFee = this.checkActive(
      this.tempContract[
        `contract_finances_hotel_${this.productToCancel.id}_supplier_fine_fee_active`
      ]
    );
  },
  methods: {
    onFinishActions() {
      this.openCancelProductModal = false;
      this.$emit("onFinishActions");
    },
    onClickCancelProduct() {
      let total = 0;
      let totalFees = 0;
      let taxInfo = "";

      this.cancelActions = [];

      if (this.fineFee) {
        totalFees += parse(
          this.tempContract[`${this.baseFinancesId}_fine_fee_value`]
        );
      }

      if (this.supplierFineFee) {
        totalFees += parse(
          this.tempContract[`${this.baseFinancesId}_supplier_fine_fee_value`]
        );
      }

      if (
        this.checkActive(
          this.tempContract[`${this.baseId}_financial_data_active`]
        )
      ) {
        total = this.newProductValues().rawTotal;
      } else {
        total = this.productValues().total.rawValue;
      }

      this.newProductValues();

      if (totalFees != 0) {
        taxInfo = `<div class="f11 red mt-5">➟ O valor de <b class="cred">${this.formatPricePtBr(
          totalFees
        )}</b> das multas foi descontado na Carta de Crédito.</div>`;
      }

      this.productTotalValue = total - totalFees;

      this.cancelActions.push({
        action: "create-credit-letter",
        text: `Uma <b>CARTA DE CRÉDITO</b> no valor de <b class="cgreen">${this.formatPricePtBr(
          total - totalFees
        )}</b> será gerada no nome do cliente <b>${
          this.tempContract.the_customer.first_name
        } ${this.tempContract.the_customer.last_name} (ID: ${
          this.tempContract.the_customer.id
        })</b>. ${taxInfo}`,
        done: false,
        loading: false,
      });

      this.cancelActions.push({
        action: "create-contract",
        text: `Um  <b>CONTRATO DE CANCELAMENTO</b> será gerado com as informações do produto.`,
        done: false,
        loading: false,
      });

      this.cancelActions.push({
        action: "create-sale",
        text: `Uma nova <b>VENDA</b> será gerada para o  <b>CONTRATO DE CANCELAMENTO</b>.`,
        done: false,
        loading: false,
      });

      this.cancelActions.push({
        action: "create-note-contract",
        text: `Uma NOTA será criada neste <b>CONTRATO (ID: ${this.tempContract.id})</b> sinalizando o cancelamento.`,
        done: false,
        loading: false,
      });

      this.openCancelProductModal = true;
    },
    productValues() {
      const total = this.allContractData.hotel.toReceiveList.filter((item) => {
        return item.id == `hotel-${this.productToCancel.id}`;
      });

      const toPay = this.allContractData.hotel.netList.filter((item) => {
        return item.id == `hotel-${this.productToCancel.id}`;
      });

      const profit = this.allContractData.hotel.profitList.filter((item) => {
        return item.id == `hotel-${this.productToCancel.id}`;
      });

      const taxes = this.allContractData.hotel.extraFeesList.filter((item) => {
        return item.id == `hotel-${this.productToCancel.id}`;
      });

      return {
        total: total.length ? total[0] : {},
        toPay: toPay.length ? toPay[0] : {},
        profit: profit.length ? profit[0] : {},
        taxes: taxes.length ? taxes[0] : {},
      };
    },
    newProductValues() {
      let total = parse(this.tempContract[`${this.baseId}_total_price_new`]);
      let toPay = parse(
        this.tempContract[`${this.baseFinancesId}_net_value_new`]
      );
      let profit = 0;
      let taxes = 0;

      if (
        this.tempContract[`${this.baseFinancesId}_taxes_rows_new`] != undefined
      ) {
        JSON.parse(
          this.tempContract[`${this.baseFinancesId}_taxes_rows_new`]
        ).forEach((tax) => {
          if (
            this.tempContract[
              `${this.baseFinancesId}_tax_${tax.id}_type_new`
            ] &&
            this.tempContract[`${this.baseFinancesId}_tax_${tax.id}_value_new`]
          ) {
            taxes += parse(
              this.tempContract[
                `${this.baseFinancesId}_tax_${tax.id}_value_new`
              ]
            );

            if (
              this.tempContract[
                `${this.baseFinancesId}_tax_${tax.id}_add_in_total_new`
              ] == true ||
              this.tempContract[
                `${this.baseFinancesId}_tax_${tax.id}_add_in_total_new`
              ] == 1
            ) {
              total += parse(
                this.tempContract[
                  `${this.baseFinancesId}_tax_${tax.id}_value_new`
                ]
              );
            }
          }
        });
      }

      if (
        this.tempContract[`${this.baseFinancesId}_incentives_rows_new`] !=
        undefined
      ) {
        JSON.parse(
          this.tempContract[`${this.baseFinancesId}_incentives_rows_new`]
        ).forEach((incentive) => {
          if (
            this.tempContract[
              `${this.baseFinancesId}_incentive_${incentive.id}_type_new`
            ] == "%"
          ) {
            profit += parseFloat(
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_percentage_value_new`
              ]
            );

            if (
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_add_in_total_new`
              ] == true ||
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_add_in_total_new`
              ] == 1
            ) {
              total += parseFloat(
                this.tempContract[
                  `${this.baseFinancesId}_incentive_${incentive.id}_percentage_value_new`
                ]
              );
            }
          } else {
            profit += parse(
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_value_new`
              ]
            );

            if (
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_add_in_total_new`
              ] == true ||
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_add_in_total_new`
              ] == 1
            ) {
              total += parse(
                this.tempContract[
                  `${this.baseFinancesId}_incentive_${incentive.id}_value_new`
                ]
              );
            }
          }
        });
      }

      return {
        total: this.formatPricePtBr(total),
        rawTotal: total,
        toPay: this.formatPricePtBr(toPay),
        rawTotalToPay: toPay,
        profit: this.formatPricePtBr(total - toPay + profit),
        rawProfit: total - toPay + profit,
        taxes: this.formatPricePtBr(taxes),
        rawTaxes: taxes,
      };
    },
    verifyProductForCancellation() {
      let disable = true;

      // const paymentMethods =
      //   this.tempContract["payment_methods_new"] != undefined
      //     ? JSON.parse(this.tempContract["payment_methods_new"])
      //     : [];

      if (["Alterar", "Cancelar"].includes(this.salesAdditiveType)) {
        if (this.fineFee) {
          if (
            !this.isEmptyOrInvalid(
              this.tempContract[`${this.baseFinancesId}_fine_fee_value`]
            )
          ) {
            disable = false;
          } else {
            disable = true;
          }
        }

        if (this.supplierFineFee) {
          if (
            !this.isEmptyOrInvalid(
              this.tempContract[
                `${this.baseFinancesId}_supplier_fine_fee_value`
              ]
            )
          ) {
            disable = false;
          } else {
            disable = true;
          }
        }
      }

      if (this.salesAdditiveType === "Alterar") {
        disable = true;

        if (
          !this.isEmptyOrInvalid(
            this.tempContract[`${this.baseId}_checkin_new`]
          ) &&
          !this.isEmptyOrInvalid(
            this.tempContract[`${this.baseId}_checkout_new`]
          ) &&
          !this.isEmptyOrInvalid(
            this.tempContract[`${this.baseId}_rates_new`]
          ) &&
          !this.isEmptyOrInvalid(
            this.tempContract[`${this.baseId}_nights_new`]
          ) &&
          !this.isEmptyOrInvalid(
            this.tempContract[`${this.baseId}_locator_new`]
          )
        ) {
          if (
            this.checkActive(
              this.tempContract[`${this.baseId}_financial_data_active`]
            )
          ) {
            if (
              !this.isEmptyOrInvalid(
                this.tempContract[`${this.baseId}_total_price_new`]
              ) &&
              !this.isEmptyOrInvalid(
                this.tempContract[`${this.baseFinancesId}_net_value_new`]
              ) &&
              !this.isEmptyOrInvalid(
                this.tempContract[`${this.baseFinancesId}_supplier_id_new`]
              )
            ) {
              disable = false;
            } else {
              disable = true;
            }
          } else {
            disable = false;
          }
        }
      }

      this.disableCancelProduct = disable;
    },
    onChangeCancelProductData(tempContract) {
      this.$emit("onChangeCancelProductData", tempContract);

      this.fineFee = this.checkActive(
        tempContract[`${this.baseFinancesId}_fine_fee_active`]
      );
      this.supplierFineFee = this.checkActive(
        tempContract[`${this.baseFinancesId}_supplier_fine_fee_active`]
      );

      this.verifyProductForCancellation();
    },
    onClickActiveTab(active) {
      this.activeTab = active;
    },
    onIsSavingData(loading) {
      this.isSavingData = loading;
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #e0e0e0;
$btn-color: #ff4545;

.is-saving {
  filter: grayscale(0);
  -webkit-filter: grayscale(0%);
  pointer-events: none;
  opacity: 0.3;
}

.data-row {
  background: #fff;
  padding: 10px;
  border: 1px solid #ddd !important;
  margin: 0 0 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  .label {
    display: block;
    font-size: 12px;
    font-weight: 500;
    color: #aaa;
  }
}

.product-cancellation {
  .travel-tabs {
    height: 642px;
    .tab-icons {
      float: left;
      border-right: 1px solid $border-color;
      width: 75px;
      height: 642px;
      text-align: center;
      .tab {
        float: left;
        height: 60px;
        width: 100%;
        line-height: 56px;
        cursor: pointer;
        transition: 0.6s;
        opacity: 0.6;
        border-bottom: 1px solid #e0e0e0;
      }
      & :hover,
      .active {
        filter: none;
        -webkit-filter: grayscale(0);
        -webkit-filter: grayscale(0%);
        opacity: 1;
      }
    }
    .tab-content {
      position: relative;
      height: 642px;
      margin-left: 75px;
      padding: 0 10px;
      .inner-content {
        overflow: auto;
        height: 595px;
        width: 101.4%;
        .tab-header {
          border-bottom: 1px solid $border-color;
          padding: 10px 0;
          font-weight: 600;
        }
      }
      .footer {
        display: flex;
        border-top: 1px solid $border-color;
        padding: 10px 0;
        align-items: center;
        .disclaimer {
          color: #3c3c3c;
          font-weight: 500;
          b {
            color: $btn-color;
          }
        }

        button {
          padding: 0px 20px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
